
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Website, WebsiteComposite } from '@/services/Website/interfaces';

export interface SslManageCertificate {
  id: number;
  type: string;
  issueDate: string;
  expireDate: string;
  autoRenew: boolean;
  altNames?: string[];
}

export interface SslManageLog {
  id: number;
  log: string;
}

export interface SslManageData {
  certificate?: SslManageCertificate | null;
  sslError?: string;
  logs?: SslManageLog[];
}

@Component
export default class SslManagePanel extends Vue {
  @Prop({ type: Object, required: true })
  public composite!: WebsiteComposite;

  @Prop({ type: Boolean, default: false })
  public busy!: boolean;

  @Prop({ type: String, default: '' })
  public errorMessage!: string;

  @Prop({ type: Object, default: () => ({}) })
  public panelData!: SslManageData;

  public confirmDeleteActive: boolean = false;

  public confirmInput: string = '';

  public get website(): Website {
    return this.composite.website;
  }

  public get certificate(): SslManageCertificate | null {
    return (this.panelData && this.panelData.certificate) || null;
  }

  public get logs(): SslManageLog[] {
    return (this.panelData && this.panelData.logs) || [];
  }

  public get confirmValid(): boolean {
    return this.confirmInput.trim().toLowerCase() === this.website.domain.toLowerCase();
  }

  public startDelete(): void {
    this.confirmDeleteActive = true;
    this.confirmInput = '';
  }

  public cancelDelete(): void {
    this.confirmDeleteActive = false;
    this.confirmInput = '';
  }

  public confirmDelete(): void {
    if (!this.confirmValid) {
      return;
    }
    this.cancelDelete();
    this.emitSubmit('delete');
  }

  public emitSubmit(operation: string, payload: Record<string, unknown> = {}): void {
    this.$emit('submit', { operation, ...payload });
  }
}
